
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Dhamal Dandiya</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm dhamaal-dandiya-year2019 section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Dhamal<span > Dandiya   Event 2019</span></h2>
        </div>
        <div class="row text-justify">
            <div class="col-md-12">

                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>DHAMAL DANDIYA DAY 1</h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">

                        <a href="https://drive.google.com/drive/u/1/folders/1-cbbqPtRRr170zQJm3M4rHh93E3hJK2v "
                            target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>

                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/1.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/2.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/2.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/3.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/3.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/4.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/4.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/4.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>



                    </ul>
                </div>

                <div class="border-line-sm"></div>

                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>DHAMAL DANDIYA DAY 2</h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">

                        <a href="https://drive.google.com/drive/u/1/folders/1ssFbHLfKLBYoygnOctOyT5sz9ZGeO1zF"
                            target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/5.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/5.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/5.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/6.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/6.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/6.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/7.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/7.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/7.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/8.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/8.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/8.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>



                    </ul>
                </div>

                <div class="border-line-sm"></div>

                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>DHAMAL DANDIYA DAY 3</h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">

                        <a href="https://drive.google.com/drive/u/1/folders/10L8NnVfedZbnXnCqMakbN-egScWgys3e"
                            target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/9.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/9.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/9.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/10.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/10.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/10.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/11.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/11.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/11.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/12.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/12.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/12.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>



                    </ul>
                </div>

                <div class="border-line-sm"></div>

                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>DHAMAL DANDIYA DAY 4</h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">

                        <a href="https://drive.google.com/drive/u/1/folders/1xltcT4ElFX3g3tgOmTpymsCp4yOr81LH"
                            target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/13.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/13.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/13.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/14.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/14.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/14.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/15.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/15.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/15.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/16.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/16.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/16.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>



                    </ul>
                </div>

                <div class="border-line-sm"></div>

                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>Dhamal Dandiya Day 5 </h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">

                        <a href="https://drive.google.com/drive/u/1/folders/1B-MVcp6ZR6seGXSh1iXBRxTjsvD7BUSp"
                            target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/17.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/17.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/17.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/18.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/18.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/18.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/19.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/19.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/19.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/20.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/20.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/20.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>



                    </ul>
                </div>

                <div class="border-line-sm"></div>

                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>Dhamal Dandiya Day 6 </h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">

                        <a href="https://drive.google.com/drive/u/1/folders/1QxY0rGGc4hngGbleA7QRx74rTL-isAjv"
                            target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/21.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/21.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/21.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/22.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/22.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/22.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/23.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/23.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/23.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/24.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/24.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/24.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>



                    </ul>
                </div>

                <div class="border-line-sm"></div>

                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>Dhamal Dandiya Day 7 </h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">

                        <a href="https://drive.google.com/drive/u/1/folders/182pHGuRd9mHpL4KFttvcVDqHl5kDSyOE"
                            target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/25.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/25.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/25.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/26.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/26.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/26.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/27.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/27.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/27.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/28.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/28.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/28.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>



                    </ul>
                </div>

                <div class="border-line-sm"></div>

                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>Dhamal Dandiya Day 8</h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">

                        <a href="https://drive.google.com/drive/u/1/folders/130QOL2z_CrLoRhCu6MBuRctvMPOgx5tz"
                            target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/29.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/29.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/29.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/30.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/30.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/30.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/31.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/31.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/31.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/32.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/32.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/32.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>



                    </ul>
                </div>

                <div class="border-line-sm"></div>

                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>Dhamal Dandiya Day 9 </h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">

                        <a href="https://urlzs.com/Uos4P" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/33.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/33.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/33.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/34.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/34.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/34.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/35.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/35.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/35.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/36.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/36.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2019/36.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>



                    </ul>
                </div>

            </div>
        </div>


    </div>
</section>
